import styled from 'styled-components';

export const Navbar = styled.header`
  align-items: center;
  color: white;
  display: flex;
  height: 100px;
  justify-content: space-between;
  top: 0px;
  width: 100%;
`;

export const Img = styled.img`
  margin-right: 0.5rem;
  width: 100%;
  max-width: 120px;
  height: auto;
  margin-left: 9rem;
  margin-left: 30px;
  width: 200px;
`;
